import { render } from "./Dashboard.vue?vue&type=template&id=6fd6f315&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=6fd6f315&scoped=true&lang=css"

import exportComponent from "/docker/app/vertikaljump/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd6f315"]])

export default __exports__